import { render, staticRenderFns } from "./ModalPendenciaGeral.vue?vue&type=template&id=70976117&scoped=true"
import script from "./ModalPendenciaGeral.vue?vue&type=script&lang=js"
export * from "./ModalPendenciaGeral.vue?vue&type=script&lang=js"
import style0 from "./ModalPendenciaGeral.vue?vue&type=style&index=0&id=70976117&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70976117",
  null
  
)

export default component.exports